import { useDispatch, useSelector } from "react-redux";
import {
  initState,
  submitData,
} from "../../../modules/reducers/agreePrivacyTerm/agreePrivacy";
import { useEffect, useState } from "react";
import { submitPrivacyAgreeApi } from "../../../api/privacyAgreeTerm/submitPrivacyAgreeApi";

const usePrivacyAgree = () => {
  const dispatch = useDispatch();
  const api = submitPrivacyAgreeApi();
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");
  const status = useSelector((state) => state.agreePrivacy.status);
  const loading = useSelector((state) => state.agreePrivacy.loading);

  const [isAgree, setIsAgree] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const submit = () => {
    const data = {
      service_name: "AGENT_CHAT",
      user_id: userId,
    };
    dispatch(submitData({ ...api, data }));
    setIsClicked(true);
  };

  useEffect(() => {
    if (status && isClicked) {
      setIsAgree(true);
    }
  }, [status, isClicked]);
  return { submit, loading, isAgree, isClicked, setIsClicked };
};

export default usePrivacyAgree;
